import { call, put, takeEvery } from 'redux-saga/effects';
import {
  getAccountStatusSuccess,
  getAccountStatusFailure,
  getFacilitiesSuccess,
  getFacilitiesFailure,
  updateAdminTermsSuccess,
  updateAdminTermsFailure,
} from 'src/Actions/Registration/registerActions';

import {
  getAccountStatusDetailsApi,
  getFacilitiesApi,
  updateAdminTermsApi,
} from 'src/Services/Registration/registerService';
import { REGISTER } from 'src/Actions/Registration/types';

export default function* registerSaga() {
  yield takeEvery(REGISTER.GET_ACCOUNT_STATUS, fetchAccountStatusDetails);
  yield takeEvery(REGISTER.GET_FACILITIES, fetchFacilities);
  yield takeEvery(REGISTER.UPDATE_ADMIN_TERMS, handleUpdateAdminTerms);
}

export function* fetchAccountStatusDetails() {
  try {
    let response = yield call(getAccountStatusDetailsApi);

    if (response && response.status === 200 && response.data) {
      yield put(getAccountStatusSuccess(response.data));
    }
  } catch (e) {
    yield put(getAccountStatusFailure(e));
  }
}

export function* fetchFacilities(payload) {
  try {
    let response = yield call(getFacilitiesApi, payload.ucmId);

    if (response && response.status === 200 && response.data) {
      yield put(getFacilitiesSuccess(response.data));
    }
  } catch (e) {
    yield put(getFacilitiesFailure(e));
  }
}

export function* handleUpdateAdminTerms(data) {
  let { payload } = data;

  try {
    let response = yield call(updateAdminTermsApi, payload);

    if (response && response.status === 200) {
      yield put(updateAdminTermsSuccess(response.data));
    }
  } catch (e) {
    yield put(updateAdminTermsFailure(e));
  }
}
